import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { InvoiceAPIService } from 'src/app/extensions/services/api/invoice-api.service';
import { DateInputFillMode, DatePickerComponent, DateInputSize } from '@progress/kendo-angular-dateinputs';
import { CheckBoxRounded } from '@progress/kendo-angular-inputs';
import { isEqual } from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { PAYMENT_STATUS } from 'src/app/extensions/constants/filtersConstants';
@Component({
  selector: 'invoice-list-filter',
  templateUrl: './invoice-list-filter.component.html',
  styleUrls: ['./invoice-list-filter.component.scss'],
  standalone: false,
})
export class InvoiceListFilterComponent implements OnInit {
  public fillModeOutline: DateInputFillMode = 'outline';
  public roundedLarge: CheckBoxRounded = 'large';
  public size: DateInputSize = 'large';
  private pageFilter: app.models.GetPagedInvoicesPageFilterModel;
  private initialFilterState: app.models.GetPagedInvoicesPageFilterModel;
  public categories: app.models.GetFilterCategoriesModel[];
  public statuses: app.models.DictionaryWithCheckbox[];
  public isOtherCategory: boolean;
  public startDate: Date;
  public endDate: Date;

  public constructor(
    private _activeModal: NgbActiveModal,
    private _invoiceAPIService: InvoiceAPIService,
    private _translateService: TranslateService
  ) {}

  public ngOnInit(): void {
    this._invoiceAPIService.getFilterCategories().subscribe(x => {
      this.categories = x;
      this.categories.forEach(x => (x.isSelected = this.pageFilter.categories.includes(x.id)));
    });

    this.statuses = [
      {
        name: this._translateService.instant('invoice.status.paid'),
        isSelected: this.pageFilter.isPaid,
        value: PAYMENT_STATUS.PAID,
      },
      {
        name: this._translateService.instant('invoice.status.notPaid'),
        isSelected: this.pageFilter.isNotPaid,
        value: PAYMENT_STATUS.NOT_PAID,
      },
      {
        name: this._translateService.instant('invoice.status.overdue'),
        isSelected: this.pageFilter.isOverdue,
        value: PAYMENT_STATUS.OVERDUE,
      },
    ];

    this.isOtherCategory = this.pageFilter.isOther;

    if (this.pageFilter.startDate) {
      this.startDate = new Date(this.pageFilter.startDate);
    }
    if (this.pageFilter.endDate) {
      this.endDate = new Date(this.pageFilter.endDate);
    }
  }

  public closeHandler() {
    this._activeModal.close(false);
  }

  public resetHandler() {
    this.pageFilter.startDate = null;
    this.pageFilter.endDate = null;
    this.pageFilter.isPaid = false;
    this.pageFilter.isNotPaid = false;
    this.pageFilter.isOverdue = false;
    this.pageFilter.categories = [];
    this.pageFilter.isOther = false;

    this._activeModal.close(isEqual(this.pageFilter, this.initialFilterState) ? false : 0);
  }

  public applyHandler() {
    this.pageFilter.categories = this.categories.filter(x => x.isSelected).map(x => x.id);
    this.pageFilter.isOther = this.isOtherCategory;
    if (this.startDate) this.pageFilter.startDate = this.startDate;
    if (this.endDate) this.pageFilter.endDate = this.endDate;
    this.statuses.map(status => {
      if (status.value === PAYMENT_STATUS.PAID) {
        this.pageFilter.isPaid = status.isSelected;
      }
      if (status.value === PAYMENT_STATUS.NOT_PAID) {
        this.pageFilter.isNotPaid = status.isSelected;
      }
      if (status.value === PAYMENT_STATUS.OVERDUE) {
        this.pageFilter.isOverdue = status.isSelected;
      }
    });
    let count = this.pageFilter.categories.length;
    if (this.pageFilter.startDate != null) count++;
    if (this.pageFilter.endDate != null) count++;
    if (this.pageFilter.isPaid) count++;
    if (this.pageFilter.isNotPaid) count++;
    if (this.pageFilter.isOverdue) count++;
    if (this.pageFilter.isOther) count++;

    this._activeModal.close(isEqual(this.pageFilter, this.initialFilterState) ? false : count);
  }

  disableStartDates = (date: Date): boolean => {
    if (this.pageFilter.endDate) {
      return date > this.pageFilter.endDate;
    }
    return false;
  };

  disableEndDates = (date: Date): boolean => {
    if (this.pageFilter.startDate) {
      return date < this.pageFilter.startDate;
    }
    return false;
  };
}
